// The number of bits in an int.
export const MAX_BITS = 32

export const DEFAULT_MARGIN = 4
